import Splide from '@splidejs/splide';

loadingAnimation();
function loadingAnimation() {
  const animationLayer = document.querySelector('.animation-layer');
  const animationContent01 = document.querySelector('.animation-layer__content-01');
  const animationContent02 = document.querySelector('.animation-layer__content-02');

  window.addEventListener('DOMContentLoaded', () => {
    // DOMの読み込みが完全に終わって3000msが経過したらアニメーションをストップする
    setTimeout(() => {
      animationLayer.classList.add('hidden');
    }, 3000);

    animationLayer.addEventListener('transitionstart', () => {
      fvSlider();
    }, { once: true });
  });
}

// スライダー周りの処理
function fvSlider() {
  // メインの処理
  const sliderControl = (speed, interval) => {
    const splide = new Splide('.fv__slider', {
      type: 'loop',
      pagination: false,
      arrows: false,
      autoplay: true,
      rewind: true,
      speed: speed,
      easing: 'ease',
      interval: interval,
      cover: true,
      heightRatio: 0.665,
      mediaQuery: 'max',
      breakpoints: {
        750: {
          speed: 800,
          interval: 6000,
          gap: '2.4rem',
        }
      }
    });

    // splide のスライドに設定されている情報を取得するための処理
    const getSlide = (index) => {
      const slider = splide.Components.Slides.getAt(index).slide;
      const sliderImg = slider.lastElementChild;
      const sliderObj = {
        imgUrl: sliderImg.src,
        targetUrl: sliderImg.getAttribute('slider-url'),
        windowTarget: sliderImg.getAttribute('window-target'),
      };

      return sliderObj;
    };

    // splide から次のスライダーと次の次のスライダーを取得したりするためのオブジェクト
    const getNextSlide = (isAfterNext = false) => {
      let slide = '';
      const sliderLength = splide.length;
      const slideIndex = splide.index;
      const generate = {
        next: () => { // 次のスライドを返す処理
          if (sliderLength < 2) {
            slide = getSlide(0);
          } else {
            if (sliderLength < slideIndex) {
              slide = getSlide(0);
            } else {
              slide = getSlide(slideIndex + 1);
            }
          }
        },
        afterNext: () => { // 次の次のスライドを返す処理
          if (sliderLength < 3) {
            slide = getSlide(0);
          } else {
            if (sliderLength < slideIndex) {
              slide = getSlide(1);
            } else {
              slide = getSlide(slideIndex + 2);
            }
          }
        },
      };

      if (!isAfterNext) {
        generate.next();
      } else {
        generate.afterNext();
      }

      return slide;
    };

    // スライドがマウントされた時に処理を始める
    splide.on('mounted', () => {
      const currentCurrentSlider = document.querySelector('.fv__grid__current-slide .current-image');
      const currentNextSlider = document.querySelector('.fv__grid__current-slide .next-image');
      const nextCurrentSlider = document.querySelector('.fv__grid__next-slide .current-image');
      const nextNextSlider = document.querySelector('.fv__grid__next-slide .next-image');

      const slide = {
        current_current: getSlide(splide.index),
        current_next: getNextSlide(),
        next_current: getNextSlide(),
        next_next: getNextSlide(true),
      };

      // current_current
      currentCurrentSlider.style.backgroundImage = `url(${slide.current_current.imgUrl})`; // 画像の設定
      currentCurrentSlider.style.transition = `opacity ${speed}ms, transform 300ms`; // transition の設定
      currentCurrentSlider.setAttribute('target', slide.current_current.windowTarget); // 別タブで開くかの設定
      // リンク先の設定
      if (slide.current_current.targetUrl !== '') {
        currentCurrentSlider.setAttribute('href', slide.current_current.targetUrl);
      } else {
        currentCurrentSlider.removeAttribute('href');
      }

      // current_next
      currentNextSlider.style.backgroundImage = `url(${slide.current_next.imgUrl})`; // 画像の設定
      currentNextSlider.style.transition = `opacity ${speed}ms, transform 300ms`; // transition の設定
      currentNextSlider.setAttribute('target', slide.current_next.windowTarget); // 別タブで開くかの設定
      // リンク先の設定
      if (slide.current_next.targetUrl !== '') {
        currentNextSlider.setAttribute('href', slide.current_next.targetUrl);
      } else {
        currentNextSlider.removeAttribute('href');
      }

      // next_current
      nextCurrentSlider.style.backgroundImage = `url(${slide.next_current.imgUrl})`; // 画像の設定
      nextCurrentSlider.style.transition = `opacity ${speed}ms, transform 300ms`; // transition の設定
      nextCurrentSlider.setAttribute('target', slide.next_current.windowTarget); // 別タブで開くかの設定
      // リンク先の設定
      if (slide.next_current.targetUrl !== '') {
        nextCurrentSlider.setAttribute('href', slide.next_current.targetUrl);
      } else {
        nextCurrentSlider.removeAttribute('href');
      }

      // next_next
      nextNextSlider.style.backgroundImage = `url(${slide.next_next.imgUrl})`; // 画像の設定
      nextNextSlider.style.transition = `opacity ${speed}ms, transform 300ms`; // transition の設定
      nextNextSlider.setAttribute('target', slide.next_next.windowTarget); // 別タブで開くかの設定 // リンク先の設定
      if (slide.next_next.targetUrl !== '') {
        nextNextSlider.setAttribute('href', slide.next_next.targetUrl);
      } else {
        nextNextSlider.removeAttribute('href');
      }

      // current-slider にマウスがホバーされたらスライダーをストップする
      currentCurrentSlider.addEventListener('mouseover', () => {
        splide.Components.Autoplay.pause();
      });

      nextCurrentSlider.addEventListener('mouseover', () => {
        splide.Components.Autoplay.pause();
      });

      // ホバーが外されたらスライダーをスタートする
      currentCurrentSlider.addEventListener('mouseout', () => {
        splide.Components.Autoplay.play();
      });

      nextCurrentSlider.addEventListener('mouseout', () => {
        splide.Components.Autoplay.play();
      });
    });

    // スライダーが切り替わるタイミングで処理を実行
    splide.on('move', () => {
      const currentCurrentSlider = document.querySelector('.fv__grid__current-slide .current-image');
      const currentNextSlider = document.querySelector('.fv__grid__current-slide .next-image');
      const nextCurrentSlider = document.querySelector('.fv__grid__next-slide .current-image');
      const nextNextSlider = document.querySelector('.fv__grid__next-slide .next-image');

      // スライダーから情報を取得するためのオブジェクト
      const slide = {
        current_current: getSlide(splide.index),
        current_next: getNextSlide(),
        next_current: getNextSlide(),
        next_next: getNextSlide(true),
      };

      // .fv__grid__next-slide の処理
      nextNextSlider.setAttribute('class', 'current-image');
      nextCurrentSlider.setAttribute('class', 'next-image');
      nextCurrentSlider.setAttribute('target', slide.next_next.windowTarget);
      // リンク先の設定
      if (slide.next_next.targetUrl !== '') {
        nextCurrentSlider.setAttribute('href', slide.next_next.targetUrl);
      } else {
        nextCurrentSlider.removeAttribute('href');
      }

      nextCurrentSlider.addEventListener('transitionend', () => {
        splide.Components.Autoplay.pause(); // スライダーを一時停止
        nextCurrentSlider.style.backgroundImage = `url(${slide.next_next.imgUrl})`;
      }, { once: true });

      // .fv__grid__current-slide の処理
      splide.on('autoplay:pause', () => {
        currentNextSlider.setAttribute('class', 'current-image');
        currentCurrentSlider.setAttribute('class', 'next-image');
        currentCurrentSlider.setAttribute('target', slide.current_next.windowTarget);
        if (slide.current_next.targetUrl !== '') {
          currentCurrentSlider.setAttribute('href', slide.current_next.targetUrl);
        } else {
          currentCurrentSlider.removeAttribute('href');
        }

        currentCurrentSlider.addEventListener('transitionend', () => {
          splide.Components.Autoplay.play();
          currentCurrentSlider.style.backgroundImage = `url(${slide.current_next.imgUrl})`;
        }, { once: true });
      });
    });

    splide.mount();
  }

  // スライダーの実行
  sliderControl(1500, 6000);
}
